import { Component } from "@angular/core";
import { UserBalloonTableColumn } from "../custom-table-column/user-balloon-table-column";
import { CustomTableValueComponent } from "./abstract-custom-table-value.component";

@Component({
    selector: 'user-balloon-table-value',
    template: `<user-balloon [user]="getValue()"></user-balloon>`
})
export class UserBalloonTableValueComponent extends CustomTableValueComponent<UserBalloonTableColumn> {

}